import { fetchApiDataV2} from "../../utils/utils";

export const fetchWatchlistShows= async (appInfo) => {
    const api = "show/watchlist";
    return await fetchApiDataV2(appInfo,api)
}